<template>
    <fragment>
         <button :type="button_type" :class="custom_class" v-if="loading" >
                    <div class="loading_container">
                    {{text}}
                    <img  class="loading_image" src="@/assets/button_loading.gif" /> 
                    </div>
        </button>
         <button @click="btnClick" :type="button_type"  :class="custom_class" v-else>
                    <div class="loading_container">
                    {{text}}
                    </div>
        </button>
    </fragment>
</template>
<script>
export default {
    props:["loading","text",'custom_class','button_type'],
    data() {
        return {
            //loading: false,
        }
    },
    methods: 
    {
        btnClick()
        {
            this.$emit("button_click");
        }
    }
}
</script>
<style lang="scss">

    @import "@/style/colors.scss";

       button 
    {
        background:$primaryColor !important;
   
    }

    .loading_container 
    {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    .loading_image 
    {
      width:30px;
      height:30px;
      margin-left:10px;
      
    }

</style>